import React, { useState } from "react";
import Candidatecard from "../candidateCard/candidateCard";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useHistory } from "react-router-dom";
import { addRoute } from "../../redux/features/candidate/candidateAuthSlice";
import { useDispatch, useSelector } from "react-redux";
import { formatToHrsMins } from "../../utils/utils";
import { logout } from "../../redux/features/authVerification/authSlice";

import "./details.scss";

const Details = () => {
  const [checked, setChecked] = useState(false);
  const { userData, token } = useSelector((state) => state.auth);
  let { details } = useSelector((state) => state.examDetail);
  let history = useHistory();
  const dispatch = useDispatch();

  const handleChange = () => {
    setChecked(!checked);
  };

  const handleProceed = () => {
    const path = "/system_Check";
    console.log(checked);
    if (checked) {
      dispatch(addRoute(path));
      history.push(path);
    }
  };
  return (
    <div className="detail-container bg-white">
      <div className="title border-bottom p-3 ">
        <h6 className="font-weight-bold text-primary mb-0">
          Profile Information
        </h6>
      </div>
      <div className="p-4 row border-bottom">
        <div className="col-lg-4 border-end">
          <Candidatecard userData={userData} />
          <div style={{ width: "13.125rem" }} className="mt-4">
            <p className="mb-0 text-info">This details are incorrect?</p>
            <a href="mailto:support@proctorme.com" className="text-customblue">
             contact support here.
            </a>
          </div>
        </div>
        <div className="col-lg-8 ps-4">
          <div className="detail-title border-bottom bg-primary mb-5">
            <h6 className="font-weight-bold text-white mb-0">Exam Details</h6>
          </div>
          <div className="row details">
            <div className="col-6 col-md-5 col-lg-4 d-flex flex-column">
              <p className="text-primary">Registered Name:</p>
              <p className="text-primary">Email Address:</p>
              <p className="text-primary">Exam Title:</p>
              <p className="text-primary">Exam ID:</p>
              <p className="text-primary">Phone Number:</p>
              <p className="text-primary">Duration:</p>
            </div>
            <div className="col-6 col-md-7 col-lg-8 d-flex flex-column">
              <p className="text-primary">{`${userData.firstName} ${userData.lastName}`}</p>
              <p className="text-primary">{`${userData.email}`}</p>
              <p className="text-primary">{`${details.title.toUpperCase()}`}</p>
              <p className="text-primary">{`${details._id.toUpperCase()}`}</p>
              <p className="text-primary">{userData.phone}</p>
              <p className="text-primary">{`${formatToHrsMins(
                details.duration
              )}`}</p>
            </div>
          </div>
          {!!token && (
            <Form.Check
              variant="darkblue"
              className="mt-5"
              type="checkbox"
              checked={checked}
              onChange={handleChange}
              label="I have reviewed and accepted that this details above is correct"
            />
          )}
        </div>
      </div>

      <div className="py-4">
        <div className="d-flex justify-content-end px-4">
          <Button
            variant="outline-danger"
            className="me-2"
            onClick={() => dispatch(logout())}
          >
            Cancel
          </Button>
          {!!token && (
            <Button
              variant="success"
              className="text-white"
              onClick={handleProceed}
              disabled={!checked}
            >
              Proceed
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Details;
